export const SERVICE_NAME = "Neo Dub Studio";
export const SERVICE_URL = "neodubstudio.com";

export const LEGAL = {
  /** The name the service trades under, and how it refers to itself in the
   *  legal documents. */
  operator: SERVICE_NAME,

  /** Registered details of the business behind the service. Left empty until
   *  registration is in place — the pages omit the sentence entirely rather
   *  than printing a placeholder, so nothing reads as unfinished. Fill both
   *  in before the site takes money: a payment provider checks them, and
   *  consumer law expects the trader behind a purchase to be identifiable. */
  registeredName: "",
  address: "",
  registration: "",

  /** Where notices, privacy requests and refund requests are received. */
  email: "neodubstudio@gmail.com",

  /** Whose law governs the agreement. */
  jurisdiction: "Ukraine",
} as const;

/** One sentence naming the business behind the service, or nothing at all
 *  while registration details are still missing. */
export function registeredDetails(): string | null {
  const parts = [LEGAL.registeredName, LEGAL.registration, LEGAL.address].filter(Boolean);
  return parts.length ? parts.join(", ") : null;
}

/** How long a paid account's projects survive after the subscription ends,
 *  in days. Short on purpose: storage costs run continuously and the
 *  subscription is what pays for them. It is not as harsh as it sounds — a
 *  failed payment does not end a subscription immediately, since Paddle
 *  retries and emails for weeks first, so this window starts well after the
 *  customer has been warned.
 *
 *  Quoted in both the Terms and the Privacy Policy; change it here only. */
export const RETENTION_DAYS_AFTER_SUBSCRIPTION = 3;

/** Bumped whenever a legal document changes materially — shown to users and
 *  used to decide whether existing customers need re-notifying. */
export const LEGAL_UPDATED = "19 September 2026";
